import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IRegister } from 'src/app/interfaces/register';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})

export class RegisterComponent implements OnInit {

  confirmation:boolean =true;
  formData:IRegister;
  sTimer:boolean = false;

  constructor(
    private titleService: Title
  ) 
  
  {}
  ngOnInit() {
    this.titleService.setTitle(environment.siteTitle);
  }

  selected(data:IRegister){
    this.confirmation  = !this.confirmation;
    this.formData = data;
  }
}
